export const saveToken = token => {
	if (token) {
		sessionStorage.setItem('token', token);
	}
};

export const getToken = () => sessionStorage.token;

export const formatUserName = (title, name) => title ? `${title} ${name}` : name;

export const formatPhone = phone => {
	let phoneMask;

	if (!phone) {
		return '';
	}

	if (phone.length === 11) {
		phoneMask = '(' + phone.slice(0, 2) + ') ' + phone.slice(2, 7) + '-' + phone.slice(7);
	} else {
		phoneMask = '(' + phone.slice(0, 2) + ') ' + phone.slice(2, 6) + '-' + phone.slice(6);
	}

	return phoneMask;
};
